<nb-layout-header subheader class="action-nav">
  <nb-actions size="small">

    <nb-action *ngIf="!isMobile">
      <strong class="mr-5">{{totalProperties}}</strong> requests
    </nb-action>



  </nb-actions>



</nb-layout-header>


<div [ngClass]="{'p-20': !isInDrawer}">


  <section class="table-container"   #tableContainer   (mousedown)="onMouseDown($event)" (mousemove)="onMouseMove($event)"  (mouseup)="onMouseUp()">

    <ng-template #noResults>
      <nb-alert accent="basic" class="empty" *ngIf="!isLoadingResults">
        <div>
          <nb-icon icon="alert-circle-outline"></nb-icon>
          No result found.
        </div>
      </nb-alert>
    </ng-template>

    <table matSort mat-table [dataSource]="properties" class="mat-elevation-z8">





      <!-- reference Column -->
      <ng-container matColumnDef="site_url">
        <th mat-header-cell *matHeaderCellDef>From</th>
        <td mat-cell *matCellDef="let property">{{ property.site_url}}</td>
      </ng-container>






      <!-- reference Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let property">{{ property.name}}</td>
      </ng-container>



      <!-- reference Column -->
      <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef>Phone</th>
        <td mat-cell *matCellDef="let property">{{ property.phone}}</td>
      </ng-container>

      <ng-container matColumnDef="message">
        <th mat-header-cell *matHeaderCellDef>Message</th>
        <td mat-cell *matCellDef="let property" style="white-space: pre-wrap;">{{ property.message }}</td>
      </ng-container>



      <!-- Price Column -->
      <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef>Created At</th>
        <td mat-cell *matCellDef="let property">{{ property.created_at | customDate }}</td>
      </ng-container>




      <ng-container matColumnDef="pagination-footer">
        <td mat-footer-cell *matFooterCellDef colspan="13">
          <app-pagination
            [isInDrawer]="isInDrawer"
            [currentPage]="currentPage"
            [totalPages]="calculateTotalPages()"
            (pageChanged)="onPageChanged($event)"
          ></app-pagination>
        </td>
      </ng-container>


      <ng-container matColumnDef="pagination">
        <th mat-header-cell *matHeaderCellDef colspan="15">
          <app-pagination
            [isInDrawer]="false"
            [currentPage]="currentPage"
            [totalPages]="calculateTotalPages()"
            (pageChanged)="onPageChanged($event)"
          ></app-pagination>



        </th>


      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['pagination']; sticky: true"></tr>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <tr mat-footer-row *matFooterRowDef="['pagination-footer']; sticky: true" class="footer-table"></tr>

    </table>


  </section>

</div>


